import gql from 'graphql-tag';

const HARDWARE_TYPES = gql`
  query Query {
    hardwareVersions {
      hardwareVersion
    }
  }
`;

export default HARDWARE_TYPES;
